import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=c642e968&scoped=true"
var script = {}
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=c642e968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c642e968",
  null
  
)

export default component.exports